import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { OrganizationService } from "../../../services/rnapi2-service/apis/api";
import {
  RnCommonId,
  RnEstimatedBillVM,
  RnOrganizationPaymentOnFileVM,
  RnOrganizationsProfileVM,
} from "../../../services/rnapi2-service/models/models";
import { SelectionService } from "../../../services/selection/selection.service";
import { ToasterService, ToastType } from "@rn-platform/frontend-shared-data-access-toaster";

@Component({
    selector: "estimated-bill-breakdown",
    templateUrl: "./estimated-bill-breakdown.component.html",
    styleUrls: ["./estimated-bill-breakdown.component.scss"],
    standalone: false
})
export class EstimatedBillBreakdownComponent implements OnInit {
  private selectionService = inject(SelectionService);
  private organizationService = inject(OrganizationService);
  private toasterService = inject(ToasterService);
  private readonly destroyRef = inject(DestroyRef);

  public selectedOrg: RnOrganizationsProfileVM = new RnOrganizationsProfileVM();
  public rnOrganizationPaymentOnFileVM: RnOrganizationPaymentOnFileVM;
  public estimatedBill: RnEstimatedBillVM;
  public loading = false;

  ngOnInit(): void {
    this.loading = true;
    this.selectionService.SelectedOrgProfile.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (result) => {
        this.selectedOrg = result;
        if (this.selectedOrg === null) return;

        this.organizationService
          .apiV2OrganizationsCurrentpaymentinfoPost({
            Id: this.selectedOrg.ID.toString(),
          })
          .subscribe({
            next: (result) => {
              if (result.Success) {
                this.rnOrganizationPaymentOnFileVM = result.data;
                this.loadEstimatedBillData();
              } else {
                console.error(result.Messages);
              }
            },
            error: (error) => {
              console.error(error);
            },
          });
      },
    );
  }

  private loadEstimatedBillData(): void {
    const message = 'There was a problem retrieving the estimated bill for this organization.';
    const id = 'apphub-estimated-bill-breakdown-load-error-toast';
    const rnCommonId: RnCommonId = {
      Id: this.selectedOrg.ID.toString(),
      AffectedOrganizationId: this.selectedOrg.ID
    };
    this.organizationService
      .apiV2OrganizationsGetEstimatedBillPost(rnCommonId)
      .subscribe({
        next: (result) => {
          if (result && result.data && result.Success && result.data) {
            this.estimatedBill = result.data;
          } else {
            let errMsg = "";
            for (let i = 0; i < result.Messages.length; i++) {
              const error = result.Messages[i];
              errMsg +=
                "\r\nCode: " +
                error.Code +
                "\r\nName: " +
                error.Name +
                "\r\nDescription: " +
                error.Description;
            }
            this.toasterService.addToast(ToastType.Error_, message, message, id, id);
          }
        },
        error: (error) => {
          console.error(error);
          this.toasterService.addToast(ToastType.Error_, message, message, id, id);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }
}
